import React, { useEffect } from "react";
import AccountsLayout from "../AccountsLayout";
import { useLocation, useParams } from "react-router-dom";
import { useStore } from "../../../Components/StateProvider";
import {
  DeleteRecord,
  GetListview,
  SuccessAlert,
  URLPRIFIX,
} from "../../../functions/api";
import Filters from "../../../Components/Fields/Filters";
import ListView from "../../../Components/Elements/ListView";
import { getStorage } from "../../../functions/localstorage";
import {
  URL_Account_Client_List,
  URL_Account_Budget_Delete,
  URL_Account_Budget_List,
} from "../../../Constancs/apiconst";
import Pagination from "../../../Components/Fields/Pagination";

const BudgetList = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { companyId } = useParams();
  const tablename = "companies";
  const tableURL = "/companies/getusers";
  const DeleteURL = "/companies/deleteusers/";
  let storage = getStorage();
  const Header = [
    ["Budget", "ledger_name"],
    ["Amount", "budget_amount"],
    ["End Period", "end_date"],
    ["Created By", "user_name"],
    ["Created Date", "created_date"],
    ["Action", "ACTION"],
  ];
  const store = useStore();
  const init = {
    filterfield: "all",
    search: "",
    sort: "asc",
    currentpage: 1,
    totalpage: 1,
  };

  useEffect(() => {
    store.setmodule("budget", init).then((res) => {
      store.stopLoading();
      store.setheader(tablename + " List");

      GetListview({
        listUrl: URL_Account_Budget_List + "/" + companyId,
        store: store,
        field: queryParams.get("field") || init.filterfield,
        search: queryParams.get("search") || init.search,
        sort: queryParams.get("sort") || init.sort,
      });
    });
  }, [queryParams.get("page")]);

  function change(props) {
    console.log("search data - ", props);
    GetListview({
      listUrl: URL_Account_Budget_List + "/" + companyId,
      store: store,
      field: props.field,
      search: props.search,
      sort: props.sort,
    });
  }
  function onpage(props) {
    console.log("Pagination number - ", props);
    GetListview({
      listUrl: URL_Account_Budget_List + "/" + companyId,
      store: store,
      field: store.getvalue("filterfield"),
      search: store.getvalue("search"),
      sort: store.getvalue("sort"),
      page: props,
    });
  }

  return (
    <div className="grid grid-rows-10 h-full ">
      <div className="row-span-1 relative">
        <Filters fields={Header} onchange={change} />
        <div className="absolute right-10 top-0">
          <button
            className="bg-primary text-secondary py-2 text-[12px] px-6 rounded-3xl"
            onClick={() => {
              store.navTo(
                "/" + URLPRIFIX + "/" + companyId + "/accounts/budget/create"
              );
            }}
          >
            {"Add Budget"}
          </button>
        </div>
      </div>
      <div className="row-span-9 h-full w-full ">
        <div
          className="py-5 px-[30px] h-full   w-full"
          contentEditable={false}
        >
          <ListView
             
            header={Header}
            records={store.getvalue("list")}
            // records={list}
            onedit={
              store.getprops("update")
                ? (index) => {
                    store.navTo(
                      `/${URLPRIFIX}/${companyId}/accounts/budget/edit/${index.id}`
                    );
                  }
                : undefined
            }
            onclick={
              store.getprops("view")
                ? (index) => {
                    store.navTo(
                      `/${URLPRIFIX}/${companyId}/accounts/budget/view/${index.id}`
                    );
                  }
                : undefined
            }
            ondelete={
              store.getprops("delete")
                ? (index) => {
                    DeleteRecord(URL_Account_Budget_Delete + index.id, {
                      modifiedBy: store.getuser().id,
                    }).then((res) => {
                      if (res.success) {
                        SuccessAlert("Deleted Successfully");
                        GetListview({
                          listUrl: URL_Account_Budget_List + "/" + companyId,
                          store: store,
                          field: store.getvalue("filterfield"),
                          search: store.getvalue("search"),
                          sort: store.getvalue("sort"),
                          page: store.getvalue("currentpage"),
                        });
                      }
                    });
                  }
                : undefined
            }
          />
          <div className="float-right mr-8 mt-6">
            <Pagination onchange={onpage} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BudgetList;
